<template>
    <transition name="fade">
      <div v-if="isModalVisible" @click="toggleModal" class="fixed inset-0 flex items-center justify-center bg-opacity-50 bg-gray-700 z-50">
        <div @click.stop="" class="p-6 bg-white rounded-xl shadow-lg max-w-xs sm:max-w-xl lg:max-w-3xl">
        
          <!-- title -->
          <div class="flex items-center justify-between">
            <h2 class="text-2xl font-bold pb-4">{{ title }}</h2>
            <div @click.prevent="toggleModal" class="cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-midgray">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
          </div>
          
          <!-- main content -->
          <slot></slot>

        </div>
      </div>
    </transition>
</template>

<script>
    export default {
      	props: {
          title: {
            type: String,
            default: null,
          },
        },
        data() {
            return {
              isOpen: false
            };
        },
        computed: {
            isModalVisible() {
              return this.isOpen;
            }
        },
        methods: {
            toggleModal() {
              this.isOpen = !this.isOpen;
            }
        },
    }
</script>

<style>
  /* turned off due z-index issues on review page */
  /* .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 500ms ease-out;
  } */
</style>